var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGearSix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 19.1429C16.8405 19.1429 19.143 16.8404 19.143 14C19.143 11.1597 16.8405 8.85718 14.0002 8.85718C11.1598 8.85718 8.8573 11.1597 8.8573 14C8.8573 16.8404 11.1598 19.1429 14.0002 19.1429Z",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4358 8.9322C21.6938 9.30149 21.9196 9.69221 22.1108 10.1001L24.8859 11.6429C25.2324 13.1949 25.236 14.8037 24.8966 16.3572L22.1108 17.9001C21.9196 18.3079 21.6938 18.6986 21.4358 19.0679L21.4894 22.2501C20.3134 23.3217 18.9214 24.1291 17.4073 24.6179L14.6751 22.9786C14.2257 23.0108 13.7746 23.0108 13.3251 22.9786L10.6037 24.6072C9.08475 24.1273 7.68824 23.323 6.51085 22.2501L6.56442 19.0786C6.30864 18.7042 6.08293 18.3101 5.88942 17.9001L3.11442 16.3572C2.76792 14.8053 2.76426 13.1964 3.10371 11.6429L5.88942 10.1001C6.08065 9.69221 6.30648 9.30149 6.56442 8.9322L6.51085 5.75006C7.6869 4.67838 9.07883 3.87099 10.593 3.3822L13.3251 5.02149C13.7746 4.98934 14.2257 4.98934 14.6751 5.02149L17.3966 3.39292C18.9155 3.87281 20.312 4.67708 21.4894 5.75006L21.4358 8.9322Z",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSix);
export default __webpack_public_path__ + "static/media/GearSix.cedaecb0809c370d6fadeacf9880102e.svg";
export { ForwardRef as ReactComponent };